// This file contains the list of all the AB ALIAS divided into sections by teams.

// Bookings
// ----------------------------

export const WAIT_FOR_BANK_INSTRUCTIONS = 'FBO_BOOK4490';
export const PRIME_CHECKOUT_FLOW = 'FBO_BOOK5433';
export const PAYMENT_TIMEOUT_MODAL = 'FBO_BOOK4492';
export const PAYMENT_RETRY_WITH_INSUFFICIENT_FUNDS = 'FBO_BOOK4411';
export const PAYMENT_RETRY_WITH_BLOCKER_ERRORS = 'FBO_BOOK4325';
export const SHOW_SAVE_CREDIT_CARD = 'FBO_BOOK4633';
export const NEW_TERMS_AND_CONDITIONS_TEXT = 'FBO_BOOK4629';
export const SHOW_NONMERCHANT_MESSAGE = 'FBO_BOOK3898';
export const SEND_CANCEL_STATUS = 'FBO_BOOK4374';
export const SKELETON_ON_FLIGHT_SUMMARY_PAGE_MB = 'FBO_BOOK4016';
export const ADD_ERROR_MESSAGE_PAYMENT_RETRY_APM = 'FBO_BOOK5071';
export const PAX_DETAILS_IN_PAY = 'FBO_BOOK3638';
export const MORE_DETAILS_AB = 'FBO_BOOK3741';
export const FLIGHTS_CHECKOUT_REDIRECTION = 'COUNTER_COUNTER773';
export const CREDIT_CARD_NUMBER_ICON = 'FBO_BOOK4155';
export const FREQUENT_FLYER_US = 'FBO_BOOK5389';
export const IDEAL_2 = 'FBO_BOOK5335';
export const FLIGHT_SUMMARY_STOPS_BAGGAGE = 'FBO_BOOK5313';
export const IMPROVE_ITINERARY_PAYMENT = 'FBO_BOOK5363';
export const GO_BACK_PAYMENT = 'FBO_BOOK4308';
export const QUEIXA_MESSAGE_PT = 'FBO_BOOK5572';
export const REPRICING_NEW_CONTENT = 'FBO_BOOK5602';
export const RESET_CHECKOUT_STATUS_AFTER_RETRY = 'FBO_BOOK5079';
export const PAYMENT_METHODS_IFRAME_D = 'FBO_BOOK5230';
export const PAYMENT_METHODS_IFRAME_M = 'FBO_BOOK5497';
export const BIN_DETECTION_IFRAME = 'FBO_BOOK5540';
export const FARE_RULES_TRAIN = 'FBO_BOOK5807';
export const RAILS_MVP = 'SSE_FC6424';
export const RAILS_WITHOUT_IATA = 'SSE_FC6597';
export const RAILS_STATION_NAMES_WITHOUT_IATA = 'SSE_FC6595';
export const RETRY_ON_ERROR_AVAILABLE_PAY_METHODS = 'OF2_OF24004';
export const SHOW_CHANGE_SEARCH = 'FBO_BOOK5464';
export const PAYPAL_MODAL_WITH_STEPS = 'FBO_BOOK5536';
export const EXPANDED_ONLY_BUYER_FORM = 'FBO_BOOK5656';
export const TRAINS_FARE_CONDITIONS = 'FBO_BOOK5807';
export const DUPLICATED_BOOKING_MODAL = 'FBO_BOOK5693';
export const NON_LATIN_MESSAGE = 'FBO_BOOK5885';
export const PAX_PAGE_LOADING_CONSIDERING_PRICE_SUMMARY = 'FBO_BOOK5839';
// END BOOKINGS

// DPF
// --------------------------------

export const DEACTIVATE_STORED_CREDIT_CARDS = 'DPF_DPF3806';

// END DPF

// DPT
// --------------------------------

export const HSA_MFE_MIGRATION = 'dpt_dpt4792';

// END DPT

// ALT
// --------------------------------

export const ALT_ANCILLARIES_CHARGES_IN_TOTAL_MOBILE = 'ALT_ALT4219_M';
export const ALT_ANCILLARIES_CHARGES_IN_TOTAL_DESKTOP = 'ALT_ALT4219_D';
export const SHOW_BAGS_SEATS_NEGATIVE_MARKUP_FLIGHT_SUMMARY = 'ALT_ALT4135_M';

// END ALT

// SSE
// --------------------------------

export const AIRLINE_QUALITY_TAG = 'SSE_FC5125';
export const AIRCRAFT_FILTER_COMPONENT = 'SSE_FC5115';
export const TICKETS_LEFT_MOBILE_COMPONENT = 'SSE_FC4237M';
export const PRIME_DAYS_BANNER_MOBILE = 'SSE_FC3610';
export const FREE_CANCELATION_US_MOBILE_COMPONENT = 'SSE_FC4133M';
export const RAILS_COMMERCIAL_CARRIERS = 'SSE_FC6557';

// END SSE

// ACME
// --------------------------------
export const PSD2_MODAL_BOOKING_SUMMARY = 'ACME_ACME3131';
// END ACME

// META
// --------------------------------

export const META_PERSUASIVE_COMPONENT = 'META_META1867';

// END META

// PRIME
// --------------------------------
export const PRIME_DEACTIVATE_EML_MODAL = 'prime-deactivate-eml-modal';
export const EQUAL_PROMINENCE_MOBILE = 'PRIME_PRIMO70M';
export const EQUAL_PROMINENCE_MOBILE_META = 'PRIME_TITANS104';
export const PRIME_DAYS_BANNER_FLIGHT_SUMMARY_MOBILE = 'PRIME_TITANS319';
export const PRIME_EML_META_M = 'PRIME_TITANS9368M';
export const PRIME_EML_META_D = 'PRIME_TITANS9368D';
export const META_ADAPTIVE_FUNNEL_MOBILE = 'PRIME_TITANS136';
export const SIDEBAR_PAX_STICKY_META = 'PRIME_TITANS10237';
// END PRIME

// BTTF
// --------------------------------
export const PRICE_FREEZE_DESKTOP = 'FAN_PLUS7920_D';
export const PRICE_FREEZE_MOBILE = 'FAN_PLUS7920_M';
// END BTTF

// GUARD
// --------------------------------
export const C4AR_DOUBLE_SELECTION_DESKTOP = 'GUARD_GUARD2368';
export const DOUBLE_PAYMENT_BUTTON_REVAMP_DESKTOP = 'GUARD_GUARD2351';

// END GUARD

// TAIT
// --------------------------------
export const BACKEND_ROUTER_MOBILE = 'tait-58-extend-next-page-query';

// END TAIT

// MAGNETS
// --------------------------------
export const NON_PRIME_CONFIRMATION_REDIRECTION = 'MAGNETS_MAGNETS946';
export const MAGNETS_MOBILE_CONFIRMATION_NONPRIME =
  'MAGNETS_MAGNETS1105_MOBILE_CONFIRMATION_NONPRIME';
export const MAGNETS_MOBILE_CONFIRMATION_PRIME =
  'MAGNETS_MAGNETS1105_MOBILE_CONFIRMATION_PRIME';
// END MAGNETS

// APES
// --------------------------------
export const PROMO_CODES_FUNNEL = 'apes_2504-promo-codes';
// END APES

// RAILS
// --------------------------------
export const HIDE_CHANGE_PAX = 'RAILS_56';
// END RAILS
